<p-toast></p-toast>
<div class="grid p-fluid">
    <div class="col-12">
        <div class="card">
            <p-toolbar>
                <div class="p-toolbar-group-left">
                    <h1 class="m-0">Leases List</h1>
                </div>
            </p-toolbar>
            <p-table #leaseTable [value]="leases" [globalFilterFields]="['suite', 'account']" [resizableColumns]="true"
                responsiveLayout="scroll" [paginator]="true" [rows]="150" [rowHover]="true" [totalRecords]="totalLeases"
                [loading]="isLeaselistLoading" [lazy]="true" (onLazyLoad)="getLeases($event)" sortField="account"
                [sortOrder]="1">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <div></div>
                        <div class="col-3">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="leaseTable.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="Search..." />
                            </span>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pResizableColumn pSortableColumn="account">
                            Account
                            <p-sortIcon field="account"></p-sortIcon>
                        </th>
                        <th>Suite</th>
                        <th>File Name</th>
                        <th>File Size</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-lease>
                    <tr>
                        <td class="mpi-text-truncate">{{ lease.location_id }} - {{ lease.account }}</td>
                        <td class="mpi-text-truncate">{{ lease.suite }}</td>
                        <td class="mpi-text-truncate">{{ lease.file_name }}</td>
                        <td class="mpi-text-truncate">{{ getFileSize(lease.file_size) }}</td>
                        <td>
<!--                            <a *ngIf="env.buildMode === 'serve'" pButton [routerLink]="['/lease-view/'+lease.id]" icon="pi pi-eye" iconPos="right" class="mr-2"></a>-->

                            <!-- <a pButton [href]="'/portal/invoices/createmonthly/'+invoice.suite+'/'+invoice.account" icon="pi pi-eye" iconPos="right" class="mr-2"></a> -->
                            <!-- <a pButton [href]="'/portal/invoices/createmonthly/'+invoice.suite+'/'+invoice.account" icon="pi pi-pencil" iconPos="right"></a> -->
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8" class="text-center"><b>No Data Found.</b></td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
